import { ComponentsOverrides, ComponentsProps, Theme } from '@mui/material';

interface M3Dialog {
    MuiDialog: {
        defaultProps?: ComponentsProps['MuiDialog'];
        styleOverrides?: ComponentsOverrides<Theme>['MuiDialog'];
    };
    MuiDialogTitle: {
        defaultProps?: ComponentsProps['MuiDialogTitle'];
        styleOverrides?: ComponentsOverrides<Theme>['MuiDialogTitle'];
        variants?: ComponentsProps['MuiDialogTitle'];
    };
    MuiDialogActions: {
        defaultProps?: ComponentsProps['MuiDialogActions'];
        styleOverrides?: ComponentsOverrides<Theme>['MuiDialogActions'];
    };
    MuiDialogContent: {
        defaultProps?: ComponentsProps['MuiDialogContent'];
        styleOverrides?: ComponentsOverrides<Theme>['MuiDialogContent'];
    };
}

export const getDialog = (theme: Theme): M3Dialog => {
    const { palette } = theme;
    return {
        MuiDialog: {
            styleOverrides: {
                paper: {
                    borderRadius: theme.shape.xl * 4,
                    backgroundColor: palette.surfaceContainerHigh.main,
                    padding: 24,
                },
            },
        },
        MuiDialogTitle: {
            defaultProps: {
                variant: 'headlineSmall',
            },
            styleOverrides: {
                root: {
                    padding: 0,
                    marginBottom: 16,
                },
            },
        },
        MuiDialogContent: {
            styleOverrides: {
                root: {
                    padding: 0,
                },
            },
        },
        MuiDialogActions: {
            styleOverrides: {
                root: {
                    padding: 0,
                    paddingTop: 24,
                },
            },
        },
    };
};
